import styled from 'styled-components';

export const GroupWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  button {
    margin-left: 5px;
    flex: 1;
  }
  .iconSetting {
    font-size: 20px;
    cursor: pointer;
  }
`;
